export default "__VITE_ASSET__OSGW$wZ4__"